import styled from "styled-components";
import { line, radii, space } from "src/theme/ui";
import { colors } from "src/theme/colors";

/**
 * A bank-account select with its "new account" button beside it — the same
 * row in the deposit dialog and the withdraw dialog.
 *
 * It began as an antd `Row` of 16- and 8-wide columns, and a grid sizes its
 * COLUMNS rather than what sits in them: the button needed 155 of the 215px
 * its third was given, so the row ended in sixty pixels of blank paper while
 * the select — the field a reader has to read an IBAN out of — stopped short
 * of the dialog's edge to make room for that gap. The field takes whatever
 * is left, the button takes its own label.
 */
export const AccountRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${space.sm}px;

  /* The button is bottom-aligned to the FIELD, not to the label above it.
     The shared AddButton sets align-self flex-start for the page's column
     layout, which in a row would hang it off the top. */
  > .ant-btn {
    align-self: flex-end;
    flex: none;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;

    > .ant-btn {
      align-self: stretch;
    }
  }
`;

export const AccountField = styled.div`
  flex: 1;
  min-width: 0;
  /* The error is taken out of the flow below. */
  position: relative;

  /* A validation message grows UNDER the select, and the row bottom-aligns
     its button to the field — so the moment an error appeared the field got
     taller and the button slid down with it, out of line with the input it
     sits beside. Lifted out of the flow, the message still reads directly
     under the field and the row keeps its height either way. */
  [role="alert"] {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 4px;
  }
`;
